import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Outlet, useLocation } from 'react-router-dom';
import {
  makeStyles,
} from '@material-ui/core';

import NavBar from '../components/General/NavBar';

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.common.blue,
  },

}));
function MainLayout() {
  const location = useLocation();
  const path = location.pathname;
  const classes = useStyles();
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${path.split('/', 2)[1]}` });
  }, [path]);

  return (
    <div className={classes.root}>
      {path.includes('/map/') ? null : <NavBar />}

      {' '}
      <Outlet />
    </div>
  );
}

export default MainLayout;
